var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-image',{attrs:{"src":_vm.$t("TermsAndConditionPath")}})
}
var staticRenderFns = []

export { render, staticRenderFns }